import { configureStore, combineReducers } from '@reduxjs/toolkit'

//reducers
import sesion from './slices/sesion';
import datosCae from './slices/datosCae';
import avanceAcademico from './slices/avanceAcademico';
import avance from './slices/avance';
import archiv from './slices/archiv';

const store = configureStore({
    reducer:{
        sesion,
        datosCae,
        avanceAcademico,
        avance,
        archiv
    }
})


export default store